<template>
  <v-dialog v-model="sessionExpired" persistent max-width="350">
    <v-card>
      <v-container>
        <v-layout row wrap>
          <v-flex xs12>
            <div class="headline text-xs-center">{{$t('login.timeout.heading')}}</div>
          </v-flex>
          <v-flex xs12 class="mt-3">
            <div class="body-1 pb-1">{{$t('login.timeout.text')}}</div>
          </v-flex>
        </v-layout>


        <div class="mt-3">
          <v-alert color="error" icon="warning" value="true" v-model="loginError" transition="scale-transition">
            {{$t('login.failed_relogin')}}
          </v-alert>
          <v-text-field autofocus name="username" :label="$t('login.username')" :id="'login-modal' + 'username'" v-model="username" disabled >{{this.username}}</v-text-field>
          <v-text-field name="password" :label="$t('login.password')" :id="'login-modal' + 'password'" type="password" @keyup.enter="login" v-model="password"></v-text-field>
          <v-btn :id="'login-modal' + 'login-button'" block color="primary" @click="login" dark>{{$t('login.login_button')}}</v-btn>
          <v-btn :id="'login-modal' + 'cancel-button'" block color="secondary" @click="cancel" dark>{{$t('login.cancel_button')}}</v-btn>
        </div>

      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import LoginPanel from './LoginPanel'
import { mapState, mapActions } from 'vuex'
import { APPLY_SESSION_EXPIRED_ACTIONS, LOGOUT, LOGIN } from '../../store/action-types'
import { SET_DRAWER_STATE } from '../../store/mutation-types'

export default {
  name: 'login-modal',
  data () {
    return {
      password: ''
    }
  },
  computed: {
    ...mapState({
      sessionExpired: state => state.profile.sessionExpired,
      loginError: state => state.profile.loginError,
      username: state => state.profile.username
    })
  },
  methods: {
    loggedIn () {
      this.applySessionExpiredActions()
    },
    login () {
      this.startingLogin = true
      let credentials = { username: this.username, password: this.password }
      this.doLogin(credentials)
      this.password = ''
    },
    cancel () {
      this.doLogout()
      this.$store.commit(SET_DRAWER_STATE, false)
      this.$router.push({name: 'Login'})
    },
    ...mapActions({
      doLogin: LOGIN,
      doLogout: LOGOUT,
      applySessionExpiredActions: APPLY_SESSION_EXPIRED_ACTIONS
    })
  },
  components: {
    LoginPanel
  }
}
</script>



// WEBPACK FOOTER //
// src/components/login/LoginModal.vue